import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
export default gql(`
  query favoritePosts {
    currentSession {
      user {
        id
        favoritePosts {
          ...PostSummaryFields
        }
      }
    }
  }
`);
